export default "__VITE_ASSET__CD89fV_Y__"